import de from './de.json';
import en from './en.json';

export const locale = 'de';

export const messages = {
  de: de,
  en: en,
};
